import { useEffect, useState } from 'react';

import ReactQuill from 'react-quill';
import { validator, isValid, errors } from 'react-validator';
import _ from 'lodash';
import * as qs from 'query-string';
import { withRouter } from 'react-router-dom';
import { t } from 'i18next';

import {
  useCheckForSubscibtionQuery,
  useCreateDiscussionMutation,
  useGetDiscussionsLazyQuery,
  useInsertDiscussionContentMutation,
} from '@school_ify/schoolify-repository/src/shared/types';

import { useAppSelector } from 'redux/hooks';
import Card from 'components/Card/Card';
import Errors from 'components/Errors/Errors';
import pushRouter from 'hooks/useRouterHelper';
// import './Discussion.scoped.scss';

import { getUser } from 'redux/authentication/auth.slice';
import Loader from 'clean/components/Loader/Loader';

import Details from './Details';

const Discussion = () => {
  const [discTitle, setDiscTitle] = useState('');
  const [content, setContent] = useState('');
  const { routePush } = pushRouter();
  const [validation, setValidation] = useState({});

  const { lesson } = qs.parse(window.location.search);
  const user = useAppSelector(getUser);
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ],
  };

  const subscriptionQuery = useCheckForSubscibtionQuery({
    variables: {
      user_id: user.id, // value for 'user_id'
      // @ts-ignore
      assignment_id: lesson, // value for 'discussions_id'
    },
    fetchPolicy: 'network-only',
  });

  const [insertDiscussionContentMutation] = useInsertDiscussionContentMutation();
  const [createDiscussionMutation] = useCreateDiscussionMutation();

  const reloadSubscription = () => {
    subscriptionQuery.refetch();
  };

  const [getDiscussion, { data, refetch }] = useGetDiscussionsLazyQuery();

  const loadDiscussion = async () => {
    await subscriptionQuery.refetch();
    if (!lesson) {
      return;
    }
    getDiscussion({
      variables: {
        _eq: lesson.toString(),
      },
    });
  };

  const save = async () => {
    validator(
      {
        content,
      },
      {
        content: ['required'],
      }
    );
    setValidation(errors());
    if (!isValid()) {
      return;
    }

    const ass_disc_id = await createDiscussionMutation({
      variables: {
        title: discTitle,
        user_id: user.id,
        // @ts-ignore
        assignment_id: lesson,
      },
    });

    await insertDiscussionContentMutation({
      variables: {
        content,
        user_id: user.id,
        assignment_discussion_id: ass_disc_id?.data?.insert_assignment_discussion_one?.id,
        parent_id: null,
      },
    });
    refetch();
    setDiscTitle('');
    setContent('');
  };

  useEffect(() => {
    loadDiscussion().then(() => {
      reloadSubscription();
    });
  }, [window.location.search]);

  const onCancelDiscussionHandler = () => {
    setDiscTitle('');
    setContent('');
    routePush({
      search: {
        section: '',
        discussion_id: null,
      },
    });
  };

  return (
    <Card className="mt-1">
      <Card.Body>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <label htmlFor="">{t('study:title')}</label>
            <input
              type="text"
              className="full-input"
              value={discTitle}
              onChange={e => setDiscTitle(e.target.value)}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">{t('study:Content')}</label>
            <ReactQuill
              style={{ border: 'none', borderRadius: '10px' }}
              theme="snow"
              value={content}
              modules={modules}
              onChange={val => setContent(val)}
            />
          </div>
        </div>
        <div className="quill-discussion-action-buttons-wrapper">
          <div className="flex mt-1 justify-end align-center gap-2">
            <label htmlFor="" className="cursor-pointer" onClick={onCancelDiscussionHandler}>
              {t('common:close')}
            </label>
            <label
              className="btn bg-primary text-white rounded-full nowrap  no-underline text-bold"
              onClick={save}
            >
              {t('common:save')}
            </label>
          </div>
          <div className="error-wrapper">
            <Errors prop="content" errors={validation} />
          </div>
        </div>

        <div className="mt-1">
          <h3 style={{ marginBottom: '10px' }}>{t('common:Discussion')}</h3>

          {!subscriptionQuery.loading &&
            data?.assignment_discussion?.map(obj => {
              return (
                <Details
                  discussion={obj}
                  subscriptionUpdate={reloadSubscription}
                  isSubscribed={_.find(subscriptionQuery.data?.assignment_discussion_subscription, [
                    'assignment_discussion_id',
                    obj.id,
                  ])}
                  key={obj.id}
                  update={() => refetch()}
                />
              );
            })}
          {subscriptionQuery.loading && (
            <div className="flex justify-center">
              <Loader size={50} />
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default withRouter(Discussion);
